<template>
  <div class="main">
    <landingBanner
      landingUrl="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/guochao/banner.jpg"
    ></landingBanner>
    <div class="content">
      <indexTitle
        title1="填写联系电话获取学费报价"
        title2="To get the tuition"
        color="#8a2a29"
      ></indexTitle>
      <footerForm color="#fff" bag="#8a2a29" words="获取学费"></footerForm>
    </div>
    <div class="content">
        <div style="width:100%;height:10px"></div>
      <indexTitle
        title1="课程亮点"
        title2="零基础学习,轻松掌握高薪技能"
        color="#8a2a29"
      ></indexTitle>
      <van-image
        src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/guochao/t3.jpg"
      >
      </van-image>
      <div class="button">
        <van-button color="#f8760a" style="width: 94%" to="chat"
          >点击了解更多</van-button
        >
      </div>
    </div>
    <div class="content">
        <div style="width:100%;height:20px"></div>
      <indexTitle
        title1="课程信息"
        title2="Course Information"
        color="#8a2a29"
      ></indexTitle>
      <van-image
        src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/guochao/t5.jpg"
      >
      </van-image>
      <div class="button"></div>
    </div>
    <div class="content">
      <indexTitle
        title1="产品展示"
        title2="中式点心经典产品 | 市场热销单品 "
        color="#8a2a29"
      ></indexTitle>
      <van-image
        src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/guochao/t7.jpg"
      >
      </van-image>
      <div class="button">
        <van-button color="#f8760a" style="width: 94%" to="chat"
          >点击了解更多</van-button
        >
      </div>
    </div>
    <div class="content">
        <div style="width:100%;height:20px"></div>
      <indexTitle
        title1="师资阵容"
        title2="资深中点名师，实操教学"
        color="#8a2a29"
      ></indexTitle>
      <van-image
        src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/guochao/t9.jpg"
      >
      </van-image>
    </div>
    <div class="content">
        <div style="width:100%;height:30px"></div>
      <h1 style="color: #8a2a29; text-align: center;margin: 0 0.67em 0;">更多热门课程推荐</h1>
       <div style="width:100%;height:10px"></div>
       <router-link to="chat">
      <van-image
        src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/guochao/t0.jpg"
      >
      </van-image>
       </router-link>
    </div>
<div style="width:100%;height:20px"></div>
    <indexTitle
      title1="填写联系电话获取学费报价"
      title2="To get the tuition"
      color="#8a2a29"
    ></indexTitle>
    <footerForm
      color="#fff"
      bag="#d20001"
      words="点击获取学费报价"
    ></footerForm>
    <div class="h25px" style="width: 100%; height: 25px"></div>
    <foot></foot>
  </div>
</template>

<script>
export default {
  components: {
    back: () => import("../../../components/head/back"),
    landingBanner: () => import("../../../components/common/landing-banner"),
    foot: () => import("@/components/foot/foot"),
    indexTitle: () => import("@/components/common/indexTitle"),
    footerForm: () => import("@/components/form/footerForm"),
  },
};
</script>

<style lang="less" scoped>
/deep/ .van-swipe__indicators {
  bottom: 15px;
  left: 10%;
}
.content {
  width: 100%;
  background: #fff;
}
.button {
  width: 100%;
  text-align: center;
  margin-top: 10px;
}
.list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 10px;
  background: #fff;
}
.list-one {
  margin-bottom: 6px;
  width: 48.5%;
}
</style>
